import * as React from 'react';
import { ComplexValue, LoadOptions } from 'app/types-shared';
import { CodeComplexValue } from 'app/area/shared/codetable/types';
import { CodeSinglePicker } from 'app/area/codetable/common';
import { ExperienceTransferTranslation } from 'app/area/experience-transfer/constants';
import { ExperienceTransferItem, ExperienceTransferItemValidation } from 'app/area/experience-transfer/form/types-store';
import { configurationAlreadyExistsKey } from 'app/area/experience-transfer/form/constants';
import { ValidationLevel } from 'ui';
import { ExtraFooterButton } from 'ui/common/select/types';

interface ExperienceTransferPickerProps {
  id: string;
  label: string;
  valueItem: CodeComplexValue<number>;
  codeOptions: CodeComplexValue<number>[];
  fetching: boolean;
  translation: ExperienceTransferTranslation;
  endpoint: string;
  validation: ExperienceTransferItemValidation;
  updateItem: (item: Partial<ExperienceTransferItem>) => void;
  loadOptions: (id: string, componentEndpoint: string, loadOptionsParams: LoadOptions, optionsParams?: any) => void;
  extraFooterButton?: ExtraFooterButton;
}

export const ExperienceTransferPicker = (props: ExperienceTransferPickerProps) => {

  const { id, label, valueItem, codeOptions, fetching, translation, endpoint, validation,
    updateItem, loadOptions, extraFooterButton } = props;

  const onChange = (value: ComplexValue<number>) => {
    updateItem({ [id]: value });
  };

  const onLoadOptions = (id: string, loadOptionsParams: LoadOptions) => {
    loadOptions(id, endpoint, loadOptionsParams);
  };

  const configurationValidation = Object.keys(validation).some(key => key === configurationAlreadyExistsKey)
    ? {
      level: ValidationLevel.error,
      messages: [{ level: ValidationLevel.error, message: '', parameters: {} }]
    } : undefined;
  const currentValidation = !!validation?.[id] ? validation[id] : undefined;

  return <CodeSinglePicker
    id={id}
    label={label}
    valueItem={valueItem}
    searchRequired={false}
    required={true}
    readOnly={false}
    minLength={1}
    size={12}
    options={codeOptions}
    fetchingOptions={fetching}
    translation={translation}
    onLoadOptions={onLoadOptions}
    onChange={onChange}
    extraFooterButton={extraFooterButton}
    validation={currentValidation || configurationValidation} />;
};
